// 레이드 보상 정산 장부(RAID-PRD 2절, 새 키 dungeonhero.raid.v1): 장비 장부 저장까지 확인된 클리어 영수증 id 목록.
// 보상 자체(골드 = save.v1 보너스 영수증, 장비·강화석·주문서 = 장비 장부 고정 id 연산)는 다른 장부에 있고, 여기는 "다시 넣을 필요 없음" 표시만 한다.
// 이 키가 없거나 깨져도 보상은 잃지 않는다: 정산이 같은 고정 id 연산을 다시 넣으면 장부가 거른다(최근 적용 목록 안). 이전 빌드는 이 키를 모른다(롤백 안전).
import type { SaveStorage } from "./save";

export const RAID_KEY = "dungeonhero.raid.v1";
/** 표시는 주가 바뀌어도 지우지 않는다: 정산은 주와 상관없이 save.v1에 남은 모든 레이드 영수증을 본다(Codex P2 #207). 주 3개라 1년에 약 150개 */

export class RaidStore {
  private readonly claimed = new Set<string>();
  constructor(private readonly storage: SaveStorage) { this.read(); }

  private read(): void {
    this.claimed.clear();
    try {
      const raw = this.storage.getItem(RAID_KEY);
      if (!raw) return;
      const v = JSON.parse(raw) as { v?: unknown; claimed?: unknown };
      if (v.v !== 1 || !Array.isArray(v.claimed)) return;
      for (const id of v.claimed) if (typeof id === "string" && id.length < 80) this.claimed.add(id);
    } catch { /* 읽기 실패·손상: 비어 있는 것으로 본다(다시 정산해도 장부가 거른다) */ }
  }

  isClaimed(id: string): boolean { return this.claimed.has(id); }

  /** 다른 탭이 표시한 영수증을 다시 읽는다(정산 전에 부른다 — 오래 열린 탭이 이미 받은 보상을 다시 넣지 않게, Codex P2 #207) */
  refresh(): void { this.read(); }

  /** 정산 확인 표시. 쓰기에 성공하면 true */
  claim(id: string): boolean {
    this.read();
    this.claimed.add(id);
    try { this.storage.setItem(RAID_KEY, JSON.stringify({ v: 1, claimed: [...this.claimed].sort() })); return true; }
    catch { this.claimed.delete(id); return false; }
  }
}
